import { useNavigation } from 'react-router'

/** Thin top bar shown while a lazy route chunk is loading. */
export function NavigationProgress() {
  const navigation = useNavigation()
  if (navigation.state === 'idle') return null

  return (
    <div role="progressbar" aria-label="Loading page" className="fixed inset-x-0 top-0 z-50 h-0.5 overflow-hidden">
      <div className="h-full w-1/3 animate-[progress_1s_ease-in-out_infinite] bg-primary" />
    </div>
  )
}
